import withMarketPromoPage from '../../../hocs/withMarketPromoPage';

export default withMarketPromoPage({
  pageName: 'Volunteering',
  titleKey: 'volunteering',
  mainPromoPicture: true,
  getImageSrc: ({ language }) => `/static/img/volunteer_${language}.png`,
  backgroundPosition: 'center',
  filters: {
    context: 'volunteerism',
  },
});
